"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaFormatter = schemaFormatter;
const index_js_1 = require("../../../errors/index.js");
const isObject_js_1 = require("../../../utils/validation/isObject.js");
const attribute_js_1 = require("./attribute.js");
const utils_js_1 = require("./utils.js");
function* schemaFormatter(schema, rawValue, { attributes, ...restOptions } = {}) {
    const { format = true, transform = true } = restOptions;
    if (!(0, isObject_js_1.isObject)(rawValue)) {
        throw new index_js_1.DynamoDBToolboxError('formatter.invalidItem', {
            message: 'Invalid item detected while formatting. Should be an object.',
            payload: { received: rawValue, expected: 'Object' }
        });
    }
    const formatters = {};
    for (const [attributeName, attribute] of Object.entries(schema.attributes)) {
        const { savedAs } = attribute;
        const sanitizedAttributeName = (0, utils_js_1.sanitize)(attributeName);
        const { isProjected, childrenAttributes } = (0, utils_js_1.matchProjection)(new RegExp(`^${sanitizedAttributeName}|^\\['${sanitizedAttributeName}']`), attributes);
        if (!isProjected) {
            continue;
        }
        const attributeSavedAs = transform ? savedAs !== null && savedAs !== void 0 ? savedAs : attributeName : attributeName;
        formatters[attributeName] = (0, attribute_js_1.attrFormatter)(attribute, rawValue[attributeSavedAs], {
            attributes: childrenAttributes,
            valuePath: [attributeSavedAs],
            ...restOptions
        });
    }
    if (transform) {
        const transformedValue = Object.fromEntries(Object.entries(formatters)
            .map(([attrName, formatter]) => [attrName, formatter.next().value])
            .filter(([, attrValue]) => attrValue !== undefined));
        if (format) {
            yield transformedValue;
        }
        else {
            return transformedValue;
        }
    }
    const formattedValue = Object.fromEntries(Object.entries(formatters)
        .map(([attrName, formatter]) => [attrName, formatter.next().value])
        .filter(([attrName, attrValue]) => { var _a; return ((_a = schema.attributes[attrName]) === null || _a === void 0 ? void 0 : _a.hidden) !== true && attrValue !== undefined; }));
    return formattedValue;
}
